import { calculateTableDimensions } from "./drawingObjects/drawTable";
import { rotateCoords } from "./rotateCoordinates";

export const handleSelection = (
  objects,
  event,
  mouseX,
  mouseY,
  selectedCircles,
  selectedTableCircles,
  setSelectedCircles,
  setSelectedTableCircles,
  circleRadius,
  circlePadding,
  edgePadding,
  selectedArea,
  setSelectedArea,
  HoldTypes,
  setOpenAccessCode,
  setCurrentHold,
  successAccess,
  setSuccessAccess,
  setAccessCode,
  currentHolds,
  setTierError,
  setSoldError,
  seatingTickets
) => {
  const filterUniqueSelectedCircles = (newFiltered) => {
    const uniqueSeats = newFiltered.reduce((acc, circle) => {
      acc[circle.seatId] = circle;
      return acc; // Return the accumulator
    }, {});

    return Object.values(uniqueSeats);
  };
  const filterUniqueSelectedAreas = (newFiltered) => {
    const uniqueSeats = newFiltered.reduce((acc, circle) => {
      acc[circle.id] = circle;
      return acc; // Return the accumulator
    }, {});

    return Object.values(uniqueSeats);
  };

  const filterUniqueSelectedTableCircles = (newFiltered) => {
    // Use reduce to create an object where the keys are unique seatIds
    const uniqueSeats = newFiltered.reduce((acc, circle) => {
      acc[circle.itemID] = circle;
      return acc;
    }, {});
    return Object.values(uniqueSeats);
  };
  function arraysEqual(arr1, arr2) {
    if (arr1.length !== arr2.length) return false;
    for (let i = 0; i < arr1.length; i++) {
      if (arr1[i] !== arr2[i]) return false;
    }
    return true;
  }
  function filterByTierID(lastUpdatedArray) {
    console.log(`last updated array`, lastUpdatedArray);
    if (
      (selectedCircles.length === 0 &&
        selectedTableCircles.length === 0 &&
        selectedArea.length === 0) ||
      lastUpdatedArray.length === 0
    )
      return;
    const lastUpdatedTierIDs = lastUpdatedArray.map(
      (item) => item.TierID || item.tierID
    );
    console.log(`last updated tier IDs`, lastUpdatedTierIDs);
    console.log(`selected circles`, selectedCircles);
    console.log(`selected table circles`, selectedTableCircles);
    console.log(`selected Areas`, selectedArea);

    /*
    array of table circles
    array of circles
    array of areas

    1. extract the tierID from the last updated array 
    2. filter the areas, circles and table circles based on the last updated tierID
    
    */

    const lastUpdatedTierID = lastUpdatedTierIDs[lastUpdatedTierIDs.length - 1];
    console.log(lastUpdatedTierID);
    const filterArrayByTierID = (array) => {
      console.log(
        array.filter(
          (item) => (item.TierID || item.tierID) === lastUpdatedTierID
          // lastUpdatedTierID.includes(item.TierID || item.tierID)
        )
      );
      return array.filter(
        (item) => (item.TierID || item.tierID) === lastUpdatedTierID
        // lastUpdatedTierID.includes(item.TierID || item.tierID)
      );
    };

    const filteredCircles = filterArrayByTierID(selectedCircles);
    const filteredTableCircles = filterArrayByTierID(selectedTableCircles);
    const filteredArea = filterArrayByTierID(selectedArea);
    const isCirclesUpdated = !arraysEqual(filteredCircles, selectedCircles);
    const isTableCirclesUpdated = !arraysEqual(
      filteredTableCircles,
      selectedTableCircles
    );
    const isAreaUpdated = !arraysEqual(filteredArea, selectedArea);

    if (isCirclesUpdated || isTableCirclesUpdated || isAreaUpdated) {
      setSelectedCircles(filteredCircles);
      setSelectedTableCircles(filteredTableCircles);
      setSelectedArea(filteredArea);
      setTierError(true);
    }
    // select the last updated
  }
  const findTicket = (tierID) => {
    return seatingTickets.find((tier) => tier.tierID === tierID);
  };
  let foundObject;
  foundObject = objects.forEach((obj) => {
    if (obj.type === "matrix") {
      if(!obj.matrix) return;
      
      // if(obj.id) 
      const spacing = obj.itemRadius * 2.2; // Assuming the same spacing as used in drawObjects
      const totalWidth =
        spacing * (obj.matrix[0].length - 1) + obj.itemRadius * 2; // Total width of the matrix
      const totalHeight =
        spacing * (obj.matrix.length - 1) + obj.itemRadius * 2; // Total height of the matrix

      const centerX = obj.x + totalWidth / 2;
      const centerY = obj.y + totalHeight / 2;
      const translatedMouseX = mouseX - centerX;
      const translatedMouseY = mouseY - centerY;

      // Reverse the rotation
      const angle = (-obj.rotation * Math.PI) / 180; // Convert degrees to radians and reverse
      const rotatedMouseX =
        translatedMouseX * Math.cos(angle) - translatedMouseY * Math.sin(angle);
      const rotatedMouseY =
        translatedMouseX * Math.sin(angle) + translatedMouseY * Math.cos(angle);

      for (let rowIndex = 0; rowIndex < obj.matrix.length; rowIndex++) {
        const rowLength = obj.matrix[0].length;
        const middleIndex = (rowLength - 1) / 2; // Middle index of the row
        for (
          let columnIndex = 0;
          columnIndex < obj.matrix[rowIndex].length;
          columnIndex++
        ) {
          // const deleted = obj.matrix[rowIndex][columnIndex].deleted;
          // console.log(deleted);
          const distanceFromMiddle = Math.abs(columnIndex - middleIndex);
                let curveOffset = 0;
                // Apply a curve formula: The farther from the middle, the lower the y-value
                if(obj.useCurveRows && obj.curveFactor)
                 curveOffset = obj.curveFactor * (1 - (distanceFromMiddle / middleIndex) ** 2);
    
          // -----------
          const spacing = obj.itemRadius * 2.2; // Adjust spacing based on your needs
          const totalWidth =
            spacing * (obj.matrix[0].length - 1) + obj.itemRadius * 2;
          const totalHeight =
            spacing * (obj.matrix.length - 1) + obj.itemRadius * 2;
          const centerX = obj.x + totalWidth / 2;
          const centerY = obj.y + totalHeight / 2;
          // -----------
          const circleX = obj.x + columnIndex * spacing + obj.itemRadius;
          const circleY = obj.y + rowIndex * spacing + obj.itemRadius + curveOffset;
          const newCoord = rotateCoords(
            circleX,
            circleY,
            centerX,
            centerY,
            -obj.rotation
          );
          const distance = Math.sqrt(
            (mouseX - newCoord.x) ** 2 + (mouseY - newCoord.y) ** 2
          );
          const assigned = findTicket(obj.matrix[rowIndex][columnIndex].tierID);
          if(obj.matrix[rowIndex][columnIndex].id === "ffbb3868-61d5-40a4-93c4-bb94c524a093-1-1") {
            console.log(distance, obj.itemRadius);
          console.log(obj.matrix[rowIndex][columnIndex], distance <= obj.itemRadius);
          }
          
          if (distance <= obj.itemRadius && assigned) {
            const seatId = obj.matrix[rowIndex][columnIndex].id;
            const deleted = obj.matrix[rowIndex][columnIndex].deleted;
            const HoldID = obj.matrix[rowIndex][columnIndex].holdID;
            const accessCode = obj.matrix[rowIndex][columnIndex];
            const TierID = obj.matrix[rowIndex][columnIndex].tierID;
            const isTaken = obj.matrix[rowIndex][columnIndex].isTaken;
            const seatName = obj.matrix[rowIndex][columnIndex].name;
            const HoldAccess = HoldTypes.filter(
              (hold) => hold.HoldID === HoldID
            );
            setCurrentHold(HoldAccess);
            
            const selected = selectedCircles.find(
              (selection) =>
                selection.objectId === obj.id &&
                selection.rowIndex === rowIndex &&
                selection.columnIndex === columnIndex &&
                selection.seatId === seatId
            );
            if (selected !== undefined) {
              // Circle already selected, remove it from selection
              setSelectedCircles((current) =>
                current.filter(
                  (circle) =>
                    !(
                      circle.objectId === obj.id &&
                      circle.rowIndex === rowIndex &&
                      circle.columnIndex === columnIndex &&
                      circle.seatId === seatId
                    )
                )
              );
            } else {
              // New selection, add circle to selectedCircles
                      console.log(obj.matrix[rowIndex][columnIndex]);
                      
              const isOpened =
                currentHolds.find((hold) => {
                  return hold.HoldID === HoldID;
                }) != undefined;
              if (
                HoldID &&
                HoldAccess.length > 0 &&
                HoldAccess[0].accessCode &&
                HoldAccess[0].accessCode.length > 0 &&
                !isTaken &&
                !isOpened &&
                !deleted
              ) {
                setOpenAccessCode(true);
              } else {
                if (isOpened && !isTaken && !deleted) {
                  setSelectedCircles((current) => {
                    let newFiltered = [
                      ...current,
                      {
                        objectId: obj.id,
                        rowIndex,
                        columnIndex,
                        seatId,
                        deleted,
                        HoldID,
                        TierID,
                        sectionName: obj.name,
                        seatName,
                        startFrom: obj.startFrom,
                      },
                    ];
                    const filtered = filterUniqueSelectedCircles(newFiltered);
                    filterByTierID(filtered);
                    return filtered;
                  });
                }
                if (!HoldID && !isTaken && !deleted) {
                  setSelectedCircles((current) => {
                    let newFiltered = [
                      ...current,
                      {
                        objectId: obj.id,
                        rowIndex,
                        columnIndex,
                        seatId,
                        deleted,
                        HoldID,
                        TierID,
                        sectionName: obj.name,
                        seatName,
                        startFrom: obj.startFrom,
                      },
                    ];
                    const filtered = filterUniqueSelectedCircles(newFiltered);
                    filterByTierID(filtered);
                    return filtered;
                  });
                } else {
                  console.log("here locked seat");
                  setSoldError(true);
                }
              }
            }
            // Prevent further actions if a circle is selected/deselected
            event.stopPropagation();
            event.preventDefault();
          }
        }
      }

      return (
        rotatedMouseX >= -totalWidth / 2 &&
        rotatedMouseX <= totalWidth / 2 &&
        rotatedMouseY >= -totalHeight / 2 &&
        rotatedMouseY <= totalHeight / 2
      );
    } 
    else if (obj.type === "table") {
      // Adjusted for TableObject, considering the circles around it
      const { adjustedWidth, adjustedHeight, leftCount, topCount } =
        calculateTableDimensions(obj, circleRadius, edgePadding);

      const totalWidth =
        leftCount > 0
          ? adjustedWidth + circleRadius * 4 + edgePadding * 2
          : adjustedWidth + circleRadius * 2 + edgePadding * 1;
      const totalHeight = adjustedHeight + circleRadius * 4 + edgePadding * 2;

      const centerX = obj.x + totalWidth / 2 - circleRadius;
      const centerY = obj.y + totalHeight / 2 - circleRadius;
      const translatedMouseX = mouseX - centerX;
      const translatedMouseY = mouseY - centerY;

      // Reverse the rotation
      const angle = (-obj.rotation * Math.PI) / 180; // Convert degrees to radians and reverse
      const rotatedMouseX =
        translatedMouseX * Math.cos(angle) - translatedMouseY * Math.sin(angle);
      const rotatedMouseY =
        translatedMouseX * Math.sin(angle) + translatedMouseY * Math.cos(angle);

      const items = obj.items;
      let leftCounter = 0;
      let rightCounter = 0;
      let topCounter = 0;
      let bottomCounter = 0;
      for (let i = 0; i < items.length; i++) {
        let circleX = 0;
        let circleY = 0;
        let distance = 0;
        const assigned = findTicket(items[i].tierID);
        const HoldID = items[i].holdID;
        if (items[i].side === "left") {
          circleX = obj.x + 0;
          circleY =
            obj.y +
            ((i + 1) * (2 * circleRadius + circlePadding) -
              circleRadius +
              edgePadding +
              (topCount > 0 ? circleRadius : 0));
          const newCoord = rotateCoords(
            circleX,
            circleY,
            centerX,
            centerY,
            -obj.rotation
          );
          distance = Math.sqrt(
            (mouseX - newCoord.x) ** 2 + (mouseY - newCoord.y) ** 2
          );
          // //console.log(centerX, circleY);
          // console.log(newCoord, circleRadius);
          if (distance < circleRadius && assigned) {
            // //console.log("clicked!", items[i].id);
            const isTaken = items[i].isTaken;
            const HoldAccess = HoldTypes.filter(
              (hold) => hold.HoldID === HoldID
            );
            setCurrentHold(HoldAccess);

            const selectionIndex = selectedTableCircles.findIndex(
              (selection) =>
                selection.objectId === obj.id &&
                selection.itemID === items[i].id
            );

            if (selectionIndex >= 0) {
              // Circle already selected, remove it from selection
              setSelectedTableCircles((current) =>
                current.filter((_, index) => index !== selectionIndex)
              );
            } else {
              // New selection, add circle to selectedCircles
              const isOpened =
                currentHolds.find((hold) => {
                  return hold.HoldID === HoldID;
                }) != undefined;
              if (
                HoldID &&
                HoldAccess.length > 0 &&
                HoldAccess[0].accessCode &&
                HoldAccess[0].accessCode.length > 0 &&
                !isTaken &&
                !isOpened
              ) {
                setOpenAccessCode(true);
              } else {
                if (isOpened && !isTaken) {
                  setSelectedTableCircles((current) => {
                    let newFilter = [
                      ...current,
                      {
                        objectId: obj.id,
                        itemID: items[i].id,
                        HoldID: items[i].holdID,
                        TierID: items[i].tierID,
                        index: items[i].index,
                        tableName: obj.name,
                      },
                    ];
                    const filtered =
                      filterUniqueSelectedTableCircles(newFilter);
                    filterByTierID(filtered);
                    return filtered;
                  });
                }
                if (!items[i].holdID && !items[i].isTaken) {
                  setSelectedTableCircles((current) => {
                    let newFilter = [
                      ...current,
                      {
                        objectId: obj.id,
                        itemID: items[i].id,
                        HoldID: items[i].holdID,
                        TierID: items[i].tierID,
                        index: items[i].index,
                        tableName: obj.name,
                      },
                    ];
                    const filtered =
                      filterUniqueSelectedTableCircles(newFilter);
                    filterByTierID(filtered);
                    return filtered;
                  });
                }
              }
            }
            // Prevent further actions if a circle is selected/deselected
            event.stopPropagation();
            event.preventDefault();
          }
          leftCounter++;
        }

        if (items[i].side === "right") {
          circleX =
            obj.x + (adjustedWidth + circleRadius * 2 + edgePadding * 2);
          circleY =
            obj.y +
            ((rightCounter + 1) * (2 * circleRadius + circlePadding) -
              circleRadius +
              edgePadding +
              (topCount > 0 ? circleRadius : 0));
          const isTaken = items[i].isTaken;
          const HoldAccess = HoldTypes.filter((hold) => hold.HoldID === HoldID);
          setCurrentHold(HoldAccess);
          const newCoord = rotateCoords(
            circleX,
            circleY,
            centerX,
            centerY,
            -obj.rotation
          );
          distance = Math.sqrt(
            (mouseX - newCoord.x) ** 2 + (mouseY - newCoord.y) ** 2
          );

          // //console.log(items[rightCounter + leftCounter]);
          if (distance < circleRadius && assigned) {
            // //console.log("clicked!", items[i].id);
            const isTaken = items[i].isTaken;
            const HoldAccess = HoldTypes.filter(
              (hold) => hold.HoldID === HoldID
            );
            setCurrentHold(HoldAccess);
            const selectionIndex = selectedTableCircles.findIndex(
              (selection) =>
                selection.objectId === obj.id &&
                selection.itemID === items[i].id
            );

            if (selectionIndex >= 0) {
              // Circle already selected, remove it from selection

              setSelectedTableCircles((current) =>
                current.filter((_, index) => index !== selectionIndex)
              );
            } else {
              // New selection, add circle to selectedCircles
              const isOpened =
                currentHolds.find((hold) => {
                  return hold.HoldID === HoldID;
                }) != undefined;
              if (
                HoldID &&
                HoldAccess.length > 0 &&
                HoldAccess[0].accessCode &&
                HoldAccess[0].accessCode.length > 0 &&
                !isTaken &&
                !isOpened
              ) {
                setOpenAccessCode(true);
              } else {
                if (isOpened && !isTaken) {
                  setSelectedTableCircles((current) => {
                    let newFilter = [
                      ...current,
                      {
                        objectId: obj.id,
                        itemID: items[i].id,
                        HoldID: items[i].holdID,
                        TierID: items[i].tierID,
                        index: items[i].index,
                        tableName: obj.name,
                      },
                    ];
                    const filtered =
                      filterUniqueSelectedTableCircles(newFilter);
                    filterByTierID(filtered);
                    return filtered;
                  });
                }
                if (!items[i].holdID && !items[i].isTaken) {
                  setSelectedTableCircles((current) => {
                    let newFilter = [
                      ...current,
                      {
                        objectId: obj.id,
                        itemID: items[i].id,
                        HoldID: items[i].holdID,
                        TierID: items[i].tierID,
                        index: items[i].index,
                        tableName: obj.name,
                      },
                    ];
                    const filtered =
                      filterUniqueSelectedTableCircles(newFilter);
                    filterByTierID(filtered);
                    return filtered;
                  });
                }
              }
            }
            // Prevent further actions if a circle is selected/deselected
            event.stopPropagation();
            event.preventDefault();
          }
          rightCounter++;
        }

        if (items[i].side === "top") {
          circleX =
            obj.x +
            ((topCounter + 1) * (2 * circleRadius + circlePadding) -
              circleRadius +
              edgePadding +
              (leftCount > 0 ? circleRadius : 0));
          circleY = obj.y + 0;
          const newCoord = rotateCoords(
            circleX,
            circleY,
            centerX,
            centerY,
            -obj.rotation
          );
          distance = Math.sqrt(
            (mouseX - newCoord.x) ** 2 + (mouseY - newCoord.y) ** 2
          );
          // //console.log(distance, circleRadius);
          // //console.log(items[rightCounter + leftCounter + topCounter]);
          if (distance < circleRadius && assigned) {
            // //console.log("clicked!", items[i].id);
            const isTaken = items[i].isTaken;
            const HoldAccess = HoldTypes.filter(
              (hold) => hold.HoldID === HoldID
            );
            setCurrentHold(HoldAccess);
            const selectionIndex = selectedTableCircles.findIndex(
              (selection) =>
                selection.objectId === obj.id &&
                selection.itemID === items[i].id
            );

            if (selectionIndex >= 0) {
              // Circle already selected, remove it from selection
              setSelectedTableCircles((current) =>
                current.filter((_, index) => index !== selectionIndex)
              );
            } else {
              // New selection, add circle to selectedCircles
              const isOpened =
                currentHolds.find((hold) => {
                  return hold.HoldID === HoldID;
                }) != undefined;
              if (
                HoldID &&
                HoldAccess.length > 0 &&
                HoldAccess[0].accessCode &&
                HoldAccess[0].accessCode.length > 0 &&
                !isTaken &&
                !isOpened
              ) {
                setOpenAccessCode(true);
              } else {
                console.log(items);

                if (isOpened && !isTaken) {
                  setSelectedTableCircles((current) => {
                    let newFilter = [
                      ...current,
                      {
                        objectId: obj.id,
                        itemID: items[i].id,
                        HoldID: items[i].holdID,
                        TierID: items[i].tierID,
                        index: items[i].index,
                        tableName: obj.name,
                      },
                    ];
                    const filtered =
                      filterUniqueSelectedTableCircles(newFilter);
                    filterByTierID(filtered);
                    return filtered;
                  });
                }
                if (!items[i].holdID && !items[i].isTaken) {
                  setSelectedTableCircles((current) => {
                    let newFilter = [
                      ...current,
                      {
                        objectId: obj.id,
                        itemID: items[i].id,
                        HoldID: items[i].holdID,
                        TierID: items[i].tierID,
                        index: items[i].index,
                        tableName: obj.name,
                      },
                    ];
                    const filtered =
                      filterUniqueSelectedTableCircles(newFilter);
                    filterByTierID(filtered);
                    return filtered;
                  });
                }
              }
            }
            // Prevent further actions if a circle is selected/deselected
            event.stopPropagation();
            event.preventDefault();
          }
          topCounter++;
        }

        if (items[i].side === "bottom") {
          circleX =
            obj.x +
            ((bottomCounter + 1) * (2 * circleRadius + circlePadding) -
              circleRadius +
              edgePadding +
              (leftCount > 0 ? circleRadius : 0));
          circleY =
            obj.y + (adjustedHeight + circleRadius * 2 + edgePadding * 2);
          const newCoord = rotateCoords(
            circleX,
            circleY,
            centerX,
            centerY,
            -obj.rotation
          );
          distance = Math.sqrt(
            (mouseX - newCoord.x) ** 2 + (mouseY - newCoord.y) ** 2
          );
          // //console.log(distance, circleRadius);
          // //console.log(items[rightCounter + leftCounter + topCounter]);
          if (distance < circleRadius && assigned) {
            // //console.log("clicked!", items[i].id);
            const isTaken = items[i].isTaken;
            const HoldAccess = HoldTypes.filter(
              (hold) => hold.HoldID === HoldID
            );
            setCurrentHold(HoldAccess);
            const selectionIndex = selectedTableCircles.findIndex(
              (selection) =>
                selection.objectId === obj.id &&
                selection.itemID === items[i].id
            );

            if (selectionIndex >= 0) {
              // Circle already selected, remove it from selection
              setSelectedTableCircles((current) =>
                current.filter((_, index) => index !== selectionIndex)
              );
            } else {
              // New selection, add circle to selectedCircles
              const isOpened =
                currentHolds.find((hold) => {
                  return hold.HoldID === HoldID;
                }) != undefined;
              if (
                HoldID &&
                HoldAccess.length > 0 &&
                HoldAccess[0].accessCode &&
                HoldAccess[0].accessCode.length > 0 &&
                !isTaken &&
                !isOpened
              ) {
                setOpenAccessCode(true);
              } else {
                if (isOpened && !isTaken) {
                  setSelectedTableCircles((current) => {
                    let newFilter = [
                      ...current,
                      {
                        objectId: obj.id,
                        itemID: items[i].id,
                        HoldID: items[i].holdID,
                        TierID: items[i].tierID,
                        index: items[i].index,
                        tableName: obj.name,
                      },
                    ];
                    const filtered =
                      filterUniqueSelectedTableCircles(newFilter);
                    filterByTierID(filtered);
                    return filtered;
                  });
                }
                if (!items[i].holdID && !items[i].isTaken) {
                  setSelectedTableCircles((current) => {
                    let newFilter = [
                      ...current,
                      {
                        objectId: obj.id,
                        itemID: items[i].id,
                        HoldID: items[i].holdID,
                        TierID: items[i].tierID,
                        index: items[i].index,
                        tableName: obj.name,
                      },
                    ];
                    const filtered =
                      filterUniqueSelectedTableCircles(newFilter);
                    filterByTierID(filtered);
                    return filtered;
                  });
                }
              }
            }
            // Prevent further actions if a circle is selected/deselected
            event.stopPropagation();
            event.preventDefault();
          }
          bottomCounter++;
        }
      }
    } else if (obj.type === "generalArea") {
      const centerX = obj.x + obj.width / 2;
      const centerY = obj.y + obj.height / 2;
      const translatedMouseX = mouseX - centerX;
      const translatedMouseY = mouseY - centerY;

      // Reverse the rotation
      const angle = (-obj.rotation * Math.PI) / 180; // Convert degrees to radians and reverse
      const rotatedMouseX =
        translatedMouseX * Math.cos(angle) - translatedMouseY * Math.sin(angle);
      const rotatedMouseY =
        translatedMouseX * Math.sin(angle) + translatedMouseY * Math.cos(angle);
      const assigned = findTicket(obj.tierID);
      if (
        rotatedMouseX >= -obj.width / 2 &&
        rotatedMouseX <= obj.width / 2 &&
        rotatedMouseY >= -obj.height / 2 &&
        rotatedMouseY <= obj.height / 2 &&
        assigned
      ) {
        const findObj = selectedArea.find((obj1) => {
          return obj1.id === obj.id;
        });
        if (findObj !== undefined) {
          setSelectedArea((current) => {
            return current.filter((n) => {
              return n.id !== obj.id;
            });
          });
        } else {
          setSelectedArea((current) => {
            let newObj = { ...obj, quantity: 1 };

            let newFilter = [...current, newObj];
            const filtered = filterUniqueSelectedAreas(newFilter);
            filterByTierID(filtered);
            return filtered;
          });
        }
      }
    }
  });
};
